import React from "react";
import { GlobalStyle } from "./globalStyle";
import { BrowserRouter } from "react-router-dom";
import { CustomThemeProvider } from "contexts/CustomThemeContext";
import { Router } from "layouts/Router";
import { DialogProvider } from "contexts/DialogContext";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "components/toast";
import { StoreProvider } from "contexts/StoreContext";

function App() {
  return (
    <div>
      <CustomThemeProvider>
        <GlobalStyle />
        <ToastContainer />
        <BrowserRouter>
          <StoreProvider>
            <DialogProvider>
              <Router />
            </DialogProvider>
          </StoreProvider>
        </BrowserRouter>
      </CustomThemeProvider>
    </div>
  );
}

export default App;
